<template>
    <!-- swiper -->
    <div class="swiper-container swiper-wrapper2">
        <swiper :options="swiperOptionb"  class="swiper-wrappe"  ref="mySwiperb">
            <div class="swiper-slide"  v-for="(item,index) in swiperItem" :key="index">
                <div class="sample" @mouseover="mouseOver(index)" @mouseleave="mouseLeave(index)" >
                    <img :src="item.img" :alt="item.title" >
                    <div class="hidden-peace" :id="hoverIndex == index ? active : ''">
                        <p class="books-name">{{item.bookname}}</p>
                        <p class="books-public">{{item.public}}</p>
                    </div>
                </div>
            </div>
        </swiper>
    </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
export default {
  name: 'swiperBar',
  components: {
    Swiper,
    SwiperSlide,
  },
  props:{
      swiperItem:{
          type:Array,
          default:[],
      }
  },
  data () {
    return {
        active:'',
        hoverIndex:-1,
        swiperOptionb: {
             autoplay: {
                disableOnInteraction: false,
                delay: 3000,
            },
            slidesPerView : 3,
		    spaceBetween : 50,
            pagination: {
                el: '.swiper-pagination',
            },
           
        }
      }
    },
    methods:{
        mouseOver(i) {
            this.active = "hidden-avtive";
            this.hoverIndex = i;
        },
            // 移出
        mouseLeave(i) {
            this.active = "";
            this.hoverIndex = i;
        }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiperb.swiper;
      }
    },
    mounted () {
    //   this.swiper.slideTo(0, 0, false);
    
    }
}
</script>




// WEBPACK FOOTER //
// src/components/swiper/Swiperb.vue